

import Addtileset from "./Addtileset.js"
import AddBuilding from "./AddBuilding.js"
import AddBillboard from "./AddBillboard.js"
import WebLayerManager from "./WebLayerManager.js"
import AddLine from "./AddLine.js"

import staticData from "../data/staticData.js"

class Controller {
  constructor() {
    this._init()
    this._buildEvent()
    this.msg = null
  }
  _buildEvent() {
    top.pop = new map3d.Function.PopUp({
      container: "ThreeContainer",
    });
    top.pop2 = new map3d.Function.PopUp({
      container: "ThreeContainer",
      toTop: 0,
    });
    top.openView = function (url) {
      window.open(url)
    }
    top.label = new map3d.Entity.Words({
      position: [0, 0],
      text: "",
      pix: 80,
      showBackground: true,
      backgroundColorOpacity: 0.6,
      needOutLine: true,
      outlineWidth: 5,
      scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1, 8.0e4, 1),
      outlineColor: "#ffffff",
      fillColor: "#000000"
    })

    let handler = new map3d.Event.MouseHandler();
    handler.add("LEFT_CLICK", (e) => {
      const position = handler.getCoordinates(e);
      let obj = handler.getObject(e);
      // if (typeof obj === 'string') {
      //   const props = AddBuilding.getPropsByInnerId(obj)
      //   console.log(props)
      // }
      if (obj && obj.properties && obj.properties.props) {
        const { dom, height } = this.getInnerDomByProperty(obj.properties.props)
        const finnaldom = this.getDom(dom, height)
        pop.html(finnaldom)
        pop.bindC3(position)
        pop.setShow(true)
        //判断是否存在全景,如不存在全景则打开一张图片,选择新的
        const vieworimg = obj.properties.props.Pano === 0 ? 'img' : 'view'
        let viewdom
        if (vieworimg === 'view') {
          viewdom = this.getIframeDom(obj.properties.viewurl)
        } else {
          viewdom = this.getImgDom(obj.properties.imgurl, obj.properties.viewurl)
        }
        pop2.toTop = height
        pop2.html(viewdom)
        pop2.bindC3(position)
        pop2.setShow(true)
      }
      console.log(position)
    })
    handler.add("MOUSE_MOVE", (e) => {
      if (this.msg) {
        const position = handler.getCoordinates(e);
        label.setShow(true)
        label.setLabel(this.msg)
        label.setPosition(position)
      }
    })
  }
  getImgDom(url, vieurl) {
    return `
    <span style="pointer-events:auto;z-index:999999;color:#fff;position:absolute;top:0px;right:-15px;cursor:pointer;" title="关闭" onclick="top.pop.setShow(false);top.pop2.setShow(false);">X</span>
    <img onclick="top.openView('${vieurl}')" src=${url} style="z-index:99999;display:flex;justify-content:space-around;position:relative;margin-top:3px;width:350px;height:270px;max-width: 100%;max-height: 100%;"/>
    `;
  }
  getIframeDom(url) {
    return `
    <span style="pointer-events:auto;z-index:999999;margin-left:color:#fff;margin-left:465px;position:relative;top:25px;right:75px;cursor:pointer;" title="关闭" onclick="top.pop.setShow(false);top.pop2.setShow(false);">X</span>
     <div style="z-index:99999;display:flex;justify-content:space-around;position:relative;margin-top:3px;">
        <iframe allowfullscreen style="width:350px;height:270px" src=${url}></iframe>
     </div>
    `;
  }
  getInnerDomByProperty(properties) {
    let dom = "";
    let count = 0
    for (let key in properties) {
      dom += `<div style="margin:5px;color:white">${key}:${properties[key]}</div>`;
      count++
    }
    return { dom: dom, height: 40 + (count - 1) * 32 };
  }
  getDom(innerDom, height) {
    return `
            <div style="padding: 3px;display:flex;flex-direction:column;
                height: ${height}px;
                width: 350px;
                box-shadow: 0px 0px 80px rgba(10, 100, 150, 1) inset;
                background: linear-gradient(
                      to left,
                      rgba(255, 255, 255, 1),
                      rgba(255, 255, 255, 1)
                    )
                    left top no-repeat,
                  linear-gradient(to bottom, rgba(255, 255, 255,1), rgba(255, 255, 255, 1))
                    left top no-repeat,
                  linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 1))
                    right top no-repeat,
                  linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 1))
                    right top no-repeat,
                  linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 1))
                    left bottom no-repeat,
                  linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 1))
                    left bottom no-repeat,
                  linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 1))
                    right bottom no-repeat,
                  linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 1))
                    right bottom no-repeat;
                background-size: 3px 20px, 20px 3px, 3px 20px, 20px 3px;">
                ${innerDom}
          </div>`;
  }
  _init() {
    map3d_viewer.viewer.mouseHandlerManager.listen("setTileseShow", (config) => {
      Addtileset.setShowAll(config)
    });
    map3d_viewer.viewer.mouseHandlerManager.listen("addLayer", (config) => {
      const type = config.type
      if (type === 'Geoserver-WMS') {
        WebLayerManager.addWMS(config)
      }
      else if (type === "Tile3dLayer") {
        Addtileset.addTileset(config)
      } else if (type === "ImageLayer") {
        WebLayerManager.addXYZ(config)
      } else if (type === "BaseMap") {
        if (config.serveceType === "WebMapTileServiceImageryProvider") {
          WebLayerManager.addWMTS(Object.assign(config.config, { id: config.id }))
        } else if (config.serveceType === "ArcGisMapServerImageryProvider") {
          WebLayerManager.addARCGIS(Object.assign(config.config, { id: config.id }))
        } else if (config.serveceType === "OpenStreetMapImageryProvider") {
          WebLayerManager.addOSM(Object.assign(config.config, { id: config.id }))
        } else if (config.serveceType === "UrlTemplateImageryProvider") {
          const layer = WebLayerManager.addXYZ(Object.assign(config.config, { id: config.id }))
          map3d_viewer.viewer.imageryLayers.lowerToBottom(layer)
        } else if (config.serveceType === "Bing") {
          WebLayerManager.addBing({
            id: config.id
          })
        }
      } else if (type === "RoadName") {
        if (config.serveceType === "WebMapTileServiceImageryProvider") {
          const layer = WebLayerManager.addWMTS(Object.assign(config.config, { id: config.id }))
          map3d_viewer.viewer.imageryLayers.raiseToTop(layer)
        } else if (config.serveceType === "ArcGisMapServerImageryProvider") {
          const layer = WebLayerManager.addARCGIS(Object.assign(config.config, { id: config.id }))
          map3d_viewer.viewer.imageryLayers.raiseToTop(layer)
        } else if (config.serveceType === "OpenStreetMapImageryProvider") {
          const layer = WebLayerManager.addOSM(Object.assign(config.config, { id: config.id }))
          map3d_viewer.viewer.imageryLayers.raiseToTop(layer)
        } else if (config.serveceType === "UrlTemplateImageryProvider") {
          const layer = WebLayerManager.addXYZ(Object.assign(config.config, { id: config.id }))
          map3d_viewer.viewer.imageryLayers.raiseToTop(layer)
        }
      } else if (type === "Polygon") {
        AddBuilding.addBuilding(config)
      } else if (type === "Point") {
        staticData._getJsonData([config.url]).then((data) => {
          const features = data[0].features
          const positions = [], properties = [], urls = []
          features.forEach((item) => {
            const props = item.properties
            const geometry = item.geometry
            const key = props[config.typeToImage.key]
            const url = config.typeToImage.typeToImage[key]
            const viewurl = config.view.url + props[config.view.lasturl]
            const imgurl = config.view.imgurl + props[config.view.lasturl]
            const position = [geometry.coordinates[0], geometry.coordinates[1], geometry.coordinates[2]]
            positions.push(position)
            properties.push({ props, viewurl, imgurl })
            urls.push(url)
          })
          AddBillboard.addGroup(config.id, positions, properties, urls)
        })
      } else if (type === "GlobeTerrain") {
        map3d_viewer.viewer.terrainProvider = Cesium.createWorldTerrain()
        AddBuilding.containers.forEach((item) => {
          window.layerManagerConfig[0].children.forEach((item2) => {
            if (item2.label === "矢量数据") {
              const c = item2.children
              c.forEach((item3) => {
                if (item3.id === item.id && item3.checked === true) {
                  item.start.then(() => {
                    item.clameToGround()
                  })
                }
              })
            }
          })
        })
      } else if (type === "CustomTerrain") {
        map3d_viewer.spd.setNewTerrain(config.url)
        AddBuilding.containers.forEach((item) => {
          window.layerManagerConfig[0].children.forEach((item2) => {
            if (item2.label === "矢量数据") {
              const c = item2.children
              c.forEach((item3) => {
                if (item3.id === item.id && item3.checked === true) {
                  item.start.then(() => {
                    item.clameToGround()
                  })
                }
              })
            }
          })
        })
      } else if (type === "Line") {
        const p = []
        staticData._getJsonData([config.url]).then((data) => {
          const features = data[0].features
          features.forEach((item) => {
            const props = item.properties
            const geometry = item.geometry
            let positions = []
            geometry.coordinates.forEach((item) => {
              positions.push(item[0], item[1], 0)
            })
            p.push(positions)
          })
          AddLine.addGroup(config.id, p, config.color, config.width, 'Normal')
        })
      }
    });
    map3d_viewer.viewer.mouseHandlerManager.listen("removeLayer", (config) => {
      const type = config.type
      if (type === 'Geoserver-WMS') {
        WebLayerManager.removeLayer(config.id)
      }
      else if
        (type === "Tile3dLayer") {
        Addtileset.removeTilesetById(config.id)
      } else if (type === "BaseMap") {
        WebLayerManager.removeLayer(config.id)
      } else if (type === "RoadName") {
        WebLayerManager.removeLayer(config.id)
      } else if (type === "ImageLayer") {
        WebLayerManager.removeLayer(config.id)
      } else if (type === "Polygon") {
        AddBuilding.setShowById(config.id, false)
      } else if (type === "Point") {
        AddBillboard.setShowById(config.id, false)
      } else if (type === "GlobeTerrain") {
        map3d_viewer.spd.removeTerrain()
        AddBuilding.containers.forEach((item) => {
          window.layerManagerConfig[0].children.forEach((item2) => {
            if (item2.label === "矢量数据") {
              const c = item2.children
              c.forEach((item3) => {
                if (item3.id === item.id && item3.checked === true) {
                  item.start.then(() => {
                    item.restoreTerrain()
                  })
                }
              })
            }
          })
        })
      } else if (type === "CustomTerrain") {
        map3d_viewer.spd.removeTerrain()
        AddBuilding.containers.forEach((item) => {
          window.layerManagerConfig[0].children.forEach((item2) => {
            if (item2.label === "矢量数据") {
              const c = item2.children
              c.forEach((item3) => {
                if (item3.id === item.id && item3.checked === true) {
                  item.start.then(() => {
                    item.restoreTerrain()
                  })
                }
              })
            }
          })
        })
      } else if (type === "Line") {
        AddLine.setShowById(config.id, false)
      }
    });
    map3d_viewer.viewer.mouseHandlerManager.listen("receiveMsg", (msg) => {
      this.msg = msg
      if (!msg) {
        label.setShow(false)
      }
    });
    map3d_viewer.viewer.mouseHandlerManager.listen("getEntity", (config) => {
      map3d_viewer.viewer.mouseHandlerManager.trigger("receiveMsg", null);
    });
    map3d_viewer.viewer.mouseHandlerManager.listen("hidePopAndList", (config) => {
      top.pop.setShow(!config)
      top.pop2.setShow(!config)
      map3d_viewer.viewer.mouseHandlerManager.trigger("showlist", !config);
    });
    map3d_viewer.viewer.mouseHandlerManager.listen("loadPOI", (config) => {

    });
  }
}

export { Controller }





// WEBPACK FOOTER //
// ./src/mapfunction/Controller.js